import React, { useState } from 'react';
import { Form, Input, Button, Card, message } from 'antd';
import { UserOutlined, LockOutlined, EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import loginBackground from '../../assets/img/bg-login.jpg';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';
import { authService } from '../../services';
import SEO from '../../components/SEO';
import './LoginPage.css';
import logo from '../../assets/img/omecap-hub.png';

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const login = useAuthStore((state) => state.login);
  const [loading, setLoading] = useState(false);

  const onFinish = async (values: { username: string; password: string }) => {
    setLoading(true);
    try {
      const response = await authService.login(values);
      if (response.data.success) {
        const userResponse = await authService.getCurrentUser(response.data.data.access);
        if (userResponse.data.success) {
          // Chỉ cho phép admin_medical_facility đăng nhập
          if (userResponse.data.data.role !== 'admin_medical_facility') {
            message.error('Bạn không có quyền truy cập trang này!');
            setLoading(false);
            return;
          }
          login(userResponse.data.data, response.data.data.access, response.data.data.refresh);
          message.success('Đăng nhập thành công!');
          navigate('/facility/dashboard');
        }
      }
    } catch (error) {
      message.error('Tên đăng nhập hoặc mật khẩu không đúng!');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <SEO
        title="Đăng nhập"
        description="Đăng nhập vào hệ thống OMECAP Hub - Quản lý phòng khám, đơn thuốc quốc gia và hóa đơn điện tử"
        canonical="/login"
      />
      <div className="login-container" style={{ backgroundImage: `url(${loginBackground})` }}>
        <div className="login-left-section">
      {/* <img src={loginBackground} alt="Login Background" /> */}
      </div>
      <div className="login-right-section">
        <div className="login-form-wrapper">
          <Card className="login-card">
            <div className="login-header">
              <div className="login-logo">
                <img src={logo} alt="Login Background" style={{ width: '200px', height: 'auto' }} />
              </div>
              <div className="login-title">
                <p>Đăng nhập</p>
              </div>
            </div>
            <Form
              name="login"
              onFinish={onFinish}
              autoComplete="off"
              layout="vertical"
              size="large"
            >
              <Form.Item
                name="username"
                rules={[{ required: true, message: 'Vui lòng nhập tài khoản!' }]}
              >
                <Input
                  prefix={<UserOutlined />}
                  placeholder="Nhập tài khoản"
                />
              </Form.Item>

              <Form.Item
                name="password"
                rules={[{ required: true, message: 'Vui lòng nhập mật khẩu!' }]}
              >
                <Input.Password
                  prefix={<LockOutlined />}
                  placeholder="Nhập mật khẩu"
                  iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                />
              </Form.Item>

              <Form.Item>
                <Button type="primary" htmlType="submit" block loading={loading}>
                  ĐĂNG NHẬP
                </Button>
              </Form.Item>
            </Form>
            <div className="login-footer">
              <p>Copyright Omecap © 2025</p>
            </div>
          </Card>
        </div>
        </div>
      </div>
    </>
  );
};

export default LoginPage;

